import { Controller } from "@hotwired/stimulus"
import axios from "axios"
import createToast from '../src/toasts'

export default class extends Controller {
  static values = { url: String }

  setCoverImageFromTime() {
    const player = videojs('video-player')

    this.disableButton()

    axios.post(this.urlValue, {
      video: { cover_image_time: player.currentTime() }
    })
    .then(response => this.createToast(response.data.toast))
    .catch(error => console.warn(error))
    .then(_response => this.enableButton())
  }

  createToast(toastHTML) {
    const toast = createToast(toastHTML)
    if (!toast) { return }

    toast.show()
  }

  disableButton() { this.element.classList.add('is--loading') }
  enableButton() { this.element.classList.remove('is--loading') }
}
